import { render, staticRenderFns } from "./TypeDocumentDetail.vue?vue&type=template&id=77d75a3a&scoped=true"
import script from "./TypeDocumentDetail.vue?vue&type=script&lang=js"
export * from "./TypeDocumentDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d75a3a",
  null
  
)

export default component.exports